import $ from 'jquery';
import _ from 'ext:lodash';

import actions from 'framework/actions';
import nearestClubStore from 'framework/stores/nearestClubStore';
import Cookies from 'cookies-js';
import Omnibox from 'components/Omnibox';
import constants from 'lib/constants';
import UrlUtils from 'lib/url-utils';
import Framework from 'framework';
import locationSharingTracking from "lib/location-sharing-tracking";

const errorMessage = 'Please enter a valid location.';

let template = `
			<div class="geolocation">
				<button class="geo-close js-geo-close">
					<span class="ico-close-sm hidden-sm-up"></span>
					<span class="ico-close hidden-xs-down"></span>
				</button>
				<div class="geo-body"></div>
				<div class="geo-search">
					<form action="">
						<fieldset>
							<legend class="sr-only">Location Confirmation Club Search Field:</legend>
							<div class="attached-btn attached-btn-blue omnifield">
								<div class="attached-btn-input form-input-action">
									<label for="geolocationSearchInput" class="sr-only">Enter City, State or Zip Code</label>
									<input id="geolocationSearchInput"
										aria-label="Location Search"
										class="form-control js-geo-search-input"
										type="text"
										placeholder="Enter City, State or Zip Code"
										data-placeholder="Enter City, State or Zip Code"/>
									<button type="button" class="form-input-btn form-input-clear" data-target="#geolocationSearchInput">
										<span class="ico-delete"></span>
										<span class="sr-only">Clear Input</span>
									</button>
									<span class="label-help-error js-geo-search-error hide">
										${errorMessage}
									</span>
								</div>
								<div class="attached-btn-action">
									<button class="btn btn-primary js-geo-search-action"><span
										class="ico-search"></span></button>
								</div>
							</div>
						</fieldset>
					</form>
					<a href="/view-all-clubs.html">View All Locations</a>
				</div>
			</div>
		`;

export default class LocationConfirmationBanner {

	constructor(club, el) {
		this.club = club;
		this.el = el;
		this.state = {
			currentTextQuery: '',
			currentQuery: null,
			lastQuery: null,
			useCurrentLocation: false,
			searchResults: []
		};
	}

	setState(newState) {
		_.assign(this.state, newState);
		this.render();
	}

	initialize() {
		this.$el = $(this.el);

		this.render();
		this.componentDidMount();
	}

	handleCloseClick(e) {
		e.preventDefault();
		this.unmount();
	}

	handleYesClick(clubLink, e) {

		if(e && typeof e.preventDefault === 'function') {
			e.preventDefault();
		}

		this.confirmClubLocation(clubLink || e.target.href);

		//unmount component
		this.unmount();
	}

	confirmClubLocation(clubLink) {
		//set a cookie for the server to use later
		Cookies.set(constants.cookieLastVisited, clubLink, { expires: Infinity});
	}

	static getLastPageCookie() {
		return Cookies.get(constants.cookieLastVisited);
	}

	unmount() {
		$(this.el).html('');
	}

	performGeolocation(e) {
		var geoOptions = {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 0
		};

		if(e && typeof e.preventDefault === 'function') {
			e.preventDefault();
		}

		function setLatLong(position) {
			this.setState({currentQuery: position.coords, useCurrentLocation: true});
			actions.searchForNearestClub(position.coords);
		}

		function geoFailed() {
			this.setState({cannotUseLocation: true});
		}
		// init SDI location sharing tracking WEB-16271
		locationSharingTracking();
		window.navigator.geolocation.getCurrentPosition(setLatLong.bind(this), geoFailed.bind(this), geoOptions);
	}

	handleSearchResults(searchResults) {
		if( // check for a text search match
			searchResults.query === this.state.currentQuery ||
			( // or a GPS search match
				searchResults.query && this.state.currentQuery &&
				searchResults.query.latitude && this.state.currentQuery.latitude &&
				searchResults.query.latitude === this.state.currentQuery.latitude &&
				searchResults.query.longitude && this.state.currentQuery.longitude &&
				searchResults.query.longitude === this.state.currentQuery.longitude
			)
		) {
			//if there is one search result, navigate to the club
			if(searchResults.clubs.length === 1) {
				let href = searchResults.clubs[0].clubPagePath;

				//track the selection
				this.confirmClubLocation(href);

				window.location = href;
			}

			if(searchResults.invalid) {
				this.omnibox.setSearchInvalid();
			} else{
				this.omnibox.setSearchValid();
				this.setState({
					lastQuery: searchResults.query,
					lastQueryText: this.state.currentTextQuery,
					searchResults: searchResults.clubs
				});
			}
		}
	}

	setSearchQuery(data){
		this.state.currentQuery = data.query;
		this.state.currentTextQuery = data.text;
		this.state.useCurrentLocation = false;
	}

	componentDidMount() {
		var $this = this.$el;
		$this.removeClass('hide');
		//js-geo-links-yes: onClick={this.handleYesClick.bind(this, window.location.pathname)}
		$('.js-geo-links-yes', $this).on('click', this.handleCloseClick.bind(this));
		//js-geo-links-no: onClick={this.performGeolocation.bind(this)}
		$('.js-geo-links-no', $this).on('click', this.performGeolocation.bind(this));
		//js-club-link: onClick={this.handleYesClick.bind(this, club.clubPagePath)}
		$('.js-club-link', $this).on('click', this.handleCloseClick.bind(this));
		//js-geo-close: onClick={this.handleCloseClick.bind(this)}
		$('.js-geo-close', $this).on('click', this.handleCloseClick.bind(this));

		window.addEventListener('unload', this.componentWillUnmount.bind(this));

		//listen to nearestClubStore
		this.unsubscribeToStore = nearestClubStore.listen(this.handleSearchResults.bind(this));

		this.omnibox = new Omnibox(this.el);

		this.omnibox.initialize({
			searchActionSelector: '.js-geo-search-action',
			searchInputSelector: '.js-geo-search-input',
			errorLabelSelector: '.js-geo-search-error',
			onSearch: this.setSearchQuery.bind(this)
		});
	}

	componentWillUnmount() {
		this.unsubscribeToStore();
	}

	renderGeoBody() {
		var output = `<span class="ico-crosshairs"></span>`;

		if(this.state.cannotUseLocation && this.state.lastQuery === null) {
			output += `
				<div>
					<p>
						We're not able to determine your location.  Please enter a location.
					</p>
				</div>
			`;
		} else if(this.state.lastQuery === null) {

			output += `
				<div>
					<p>
						<strong>${this.club.name}</strong> appears to be the closest Life Time location to you, is
						this correct? &nbsp;
					<span class="geo-links">
						<a class="js-geo-links-yes" href="#" >Yes</a>
						<span class="geo-links-divide">
							|
						</span>
						<a class="js-geo-links-no" href="#">No, detect again</a>
					</span>
					</p>
				</div>
			`;
		} else if(this.state.searchResults.length) {
			let nearLocationText = this.state.useCurrentLocation ? ' you' : ` ${this.state.lastQueryText}`;
			let clubLinks = this.state.searchResults.map((club)=> {
				let locationUrl = Framework.global.location;
				let hrefPath = '#';
				let onClick = '';
				if(Framework.global.lt.club){
					hrefPath = UrlUtils.subPagePath(club.clubPagePath, locationUrl.href, locationUrl.search);
				}else{
					var clubData = {
						id: String(club.mmsClubId),
						name: club.name,
						link: club.clubPagePath
					};
					onClick = 'onclick=\'window.ef.recentClubStore.addRecentClub(' + JSON.stringify(clubData) + ', true);\'';
				}
				let clubListItem = `
					<li>
						<a data-club="${club.name}" href="${hrefPath}" ${onClick}>
							${club.name} (${club.distance} miles)
						</a>
					</li>
				`;
				return clubListItem;
			}).join('\n');
			let conjunction = this.state.searchResults.length === 1 ? 'is' : 'are';
			let locationText = this.state.searchResults.length === 1 ? 'location' : 'locations';
			output += `
				<div>
					<p>
						There ${conjunction} <strong>${this.state.searchResults.length}</strong> ${locationText} near
						<strong>${nearLocationText}</strong>:
					</p>
					<ul class="js-club-links">
						${clubLinks}
					</ul>
				</div>
			`;

		} else{
			let lastQueryText = this.state.useCurrentLocation ? 'your location' : this.state.lastQueryText;

			output += `
				<div><p>There are no clubs within <strong>50 miles</strong> of
					<strong> ${lastQueryText}</strong></p></div>
			`;
		}

		return output;
	}

	getTemplate() {
		this.cachedTemplate = $(template);
		return this.cachedTemplate;
	}

	render() {

		var geoBody = this.renderGeoBody();
		var needsAppend = _.isUndefined(this.cachedTemplate);
		var html = this.cachedTemplate || this.getTemplate();

		html.find('.geo-body').html(geoBody);

		if(needsAppend) {
			this.$el.append(html);
		}

		var clubPath = '';
		if(this.club && this.club.pages && this.club.pages.clubHome) {
			clubPath = this.club.pages.clubHome;
		}else if(this.club && this.club.link) {
			clubPath = this.club.link;
		}

		// set the cookie so this does not show again
		if(clubPath) {
			Cookies.set(constants.cookieLastVisited, clubPath, { expires: Infinity});
		}
	}
}
